import React from "react";
import {Nav, Row} from "react-bootstrap";
import List from "./List";
import ArrowWhite from "../Shared/icons/ArrowWhite";

function JobOpportunityTabsMobile({currentStatus, statusText, tabs, buttonText, scrollToForm}) {

    return (
        <>
            <Row className="row">
                {tabs.map((item) => (
                    <div id={item.name} key={item.name} className="pb-8">
                        <div className="container">
                            <h3 className="card-title">{item.name}</h3>
                            <div className="card-ul-arrow card-ul-arrow--nopadding"
                                 dangerouslySetInnerHTML={{__html: item.content}}>

                            </div>
                        </div>
                    </div>
                ))}

                <div className="container">
                    {currentStatus &&
                        <List status={currentStatus}
                              text={statusText}
                        />
                    }
                    <Nav variant="pills" className="flex-column">
                        {buttonText && currentStatus !== "closed" &&
                            <div className="mt-4">
                                <a href="#" onClick={scrollToForm}
                                   className="w-auto btn btn-success justify-content-between d-inline-flex">
                                    <span className="">{buttonText}</span>
                                    <ArrowWhite/>
                                </a>
                            </div>
                        }
                    </Nav>
                </div>
            </Row>
        </>
    );
}

export default JobOpportunityTabsMobile;